import { useEffect, useState } from "react";
import { Database, Edit2, Save, X } from "lucide-react";
import { adminGetRetentionConfigs, adminUpdateRetentionConfig } from "../../library/allauth";
import AdminGuard from "../../components/admin/AdminGuard"; // <-- Add this import

export default function RetentionPolicies() {
  const [policies, setPolicies] = useState([]);
  const [loading, setLoading] = useState(true);
  const [editingId, setEditingId] = useState(null);
  const [editValue, setEditValue] = useState("");

  const fetchPolicies = async () => {
    setLoading(true);
    try {
      const res = await adminGetRetentionConfigs();
      if (res.status === 200) {
        setPolicies(res.data);
      }
    } catch (error) {
      console.error("Failed to load retention policies:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchPolicies();
  }, []);

  const handleSave = async (id) => {
    try {
      const res = await adminUpdateRetentionConfig(id, { 
        config_value: parseInt(editValue) 
      });

      if (res.status === 200) {
        setPolicies(policies.map(p => 
          p.id === id ? { ...p, config_value: parseInt(editValue) } : p
        ));
        setEditingId(null);
      }
    } catch (error) {
      console.error("Failed to save retention policy:", error);
    }
  };


  return (
    <div className="max-w-6xl mx-auto">
      {/* Page Header */}
      <div className="mb-8">
        <h1 className="text-xl font-semibold text-gray-900">Data Retention Policies</h1>
        <p className="text-sm text-gray-400 mt-0.5">
          Manage how many days data is kept before being purged by the retention daemon.
        </p>
      </div>

      {/* Main Content Card */}
      <div className="bg-white rounded-xl border border-gray-200 overflow-hidden">
        <table className="w-full text-left border-collapse">
          <thead>
            <tr className="bg-gray-50 border-b border-gray-200 text-sm text-gray-500">
              <th className="p-4 font-medium">Data Type (Config Name)</th>
              <th className="p-4 font-medium">Retention Period (Days)</th>
              <th className="p-4 font-medium text-right">Actions</th>
            </tr>
          </thead>
          <tbody className="divide-y divide-gray-100">
            {loading ? (
              <tr>
                <td colSpan="3" className="p-8 text-center text-gray-400">Loading policies...</td>
              </tr>
            ) : (
              policies.map((policy) => (
                <tr key={policy.id} className="hover:bg-gray-50 transition-colors">
                  <td className="p-4 text-sm font-medium text-gray-900">
                    {policy.config_name}
                  </td>
                  <td className="p-4 text-sm text-gray-600">
                    {editingId === policy.id ? (
                      <input
                        type="number"
                        min="1"
                        className="border border-gray-300 rounded-lg px-3 py-1.5 w-24 focus:ring-2 focus:ring-blue-500 focus:border-blue-500 outline-none"
                        value={editValue}
                        onChange={(e) => setEditValue(e.target.value)}
                      />
                    ) : (
                      <span className="bg-gray-100 px-3 py-1 rounded-full font-medium">
                        {policy.config_value} days
                      </span>
                    )}
                  </td>
                  <td className="p-4 text-right">
                    {editingId === policy.id ? (
                      <div className="flex justify-end gap-2">
                        <button 
                          onClick={() => handleSave(policy.id)}
                          className="p-1.5 bg-green-50 text-green-600 rounded hover:bg-green-100 transition-colors"
                        >
                          <Save size={16} />
                        </button>
                        <button 
                          onClick={() => setEditingId(null)}
                          className="p-1.5 bg-red-50 text-red-600 rounded hover:bg-red-100 transition-colors"
                        >
                          <X size={16} />
                        </button>
                      </div>
                    ) : (
                      <button 
                        onClick={() => {
                          setEditingId(policy.id);
                          setEditValue(policy.config_value);
                        }}
                        className="p-1.5 text-gray-400 hover:text-blue-600 hover:bg-blue-50 rounded transition-colors"
                      >
                        <Edit2 size={16} />
                      </button>
                    )}
                  </td>
                </tr>
              ))
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
} 